<template>
  <div class="mc-video-history-new__playlist-section-wrapper">
    <div v-if="vehicleIdActive" class="mc-video-history-new__playlist-header-warapper">
      <div class="mc-video-history-new__playlist-header-left">
        <div class="mc-video-history-new__playlist-nav-wrapper">
          <McButton
            class="nav-button"
            :class="{ active: activeTab === 'timeline' }"
            size="sm"
            :text="'Timeline'"
            variant="none"
            @click="$store.commit('videoHistory/setActiveTab', 'timeline')"
          />
          <McButton
            class="nav-button"
            :class="{ active: activeTab === 'filelist' }"
            size="sm"
            :text="$t('videoHistory.videoList')"
            variant="none"
            @click="$store.commit('videoHistory/setActiveTab', 'filelist')"
          />
        </div>
        <McAlert
          :withIcon="true"
          variant="warning"
          :text="'Memainkan lebih dari 1 kamera akan meningkatkan pemakaian kuota Anda'"
        />
      </div>
      <div class="mc-video-history-new__playlist-header-action-wrapper">
        <span
          class="mc-video-history-new__playlist-header-reload-wrapper"
          :class="{ disabled: loadingFilelist }"
          @click="clickReloadFilelist()"
        >
          <i class="icon-fill_refresh" />
          {{ $t('videoHistory.video.reload') }}
        </span>
        <McButton
          v-if="activeTab === 'timeline'"
          size="sm"
          :text="$t('global.action.download')"
          variant="outline-primary"
          icon="icon-outline_download"
          @click="openModalDownload()"
        />
      </div>
    </div>
    <div class="mc-video-history-new__playlist-scroll-wrapper">
      <TimelineBarSection
        v-show="activeTab === 'timeline'"
        :status-text="statusText"
        :device-type-active="deviceTypeActive"
      />
      <FileListSection v-show="activeTab === 'filelist'" />
      <div
        v-if="!vehicleIdActive"
        class="mc-video-history-new__playlist-no-vehicle-content-wrapper"
      >
        <img
          width="180"
          src="@/assets/images/nofilter.png"
          alt="no-filter"
          class="mc-video-history-new__no-filter-illustration"
        />
        <div class="mc-video-history-new__no-filter-content-text-wrapper">
          <h3>{{ $t('videoHistory.noFilter.title') }}</h3>
          <p>{{ $t('videoHistory.noFilter.descMultiChannel') }}</p>
        </div>
      </div>
    </div>

    <ModalDownload :section-active="activeTab" />
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import TimelineBarSection from './TimelineBarSection/index.vue'
import FileListSection from './FileListSection/index.vue'
import McAlert from '@/components/McAlert'
import ModalDownload from '../Modal/ModalDownload.vue'
import { mapState } from 'vuex'

export default {
  components: {
    McButton,
    McAlert,
    FileListSection,
    TimelineBarSection,
    ModalDownload,
  },
  props: {
    statusText: {
      type: String,
      required: false,
      default: '',
    },
    deviceTypeActive: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('videoHistory', ['loadingFilelist', 'vehicleIdActive', 'activeTab']),
  },
  methods: {
    openModalDownload() {
      this.$bvModal.show('modal-download-video-history')
    },
    clickReloadFilelist() {
      this.$store.dispatch('videoHistory/reloadFilelist')
    },
  },
}
</script>
